import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import { Navigate } from 'react-router-dom';

const CvCompleteView = (props) => {
  // if (localStorage.getItem("token") != null) {
  return (
    <>
      <div className="registration-form_main">
        <div
          className="registration-form_wrapper"
          style={{ padding: '78px 73px' }}
        >
          <div className="dashboard-body-area" style={{ width: '100%' }}>
            <section className="dashboard-page-title">
              <h2>
                You have successfully submitted your application. A member of
                our staff will review your submission and contact you for an
                interview when appropriate to do so.
              </h2>
              <br />
              <h2>The following details our now own file with our office.</h2>
            </section>
            <section className="dashboard-page-title">
              <h2>
                <strong>Step 1: Personal Details Summary </strong>
              </h2>
            </section>
            <div style={{ marginTop: '30px' }}>
              <Table responsive>
                <tbody>
                  <tr>
                    <td style={{ minWidth: '15em' }}>First Name</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.first_name}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Last Name</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.last_name}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Email Address</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.email}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Job Title</td>
                    <td>
                      <span className="title-crop">{props.title_type}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Date of Birth</td>
                    <td>
                      <span className="title-crop">{props.formated_date}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ minWidth: '15em' }}>Post Code</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.zipcode}
                      </span>
                    </td>
                  </tr>
                  {props.perssonal_detail.address_line_1 &&
                    props.perssonal_detail.address_line_1 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 1</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_1}</span>
                        </td>
                      </tr>
                    )}

                  {props.perssonal_detail.address_line_2 &&
                    props.perssonal_detail.address_line_2 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 2</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_2}</span>
                        </td>
                      </tr>
                    )}

                  {props.perssonal_detail.address_line_3 &&
                    props.perssonal_detail.address_line_3 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 3</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_3}</span>
                        </td>
                      </tr>
                    )}

                  <tr>
                    <td style={{ minWidth: '15em' }}>Country</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.country}
                      </span>
                    </td>
                  </tr>
                  {props.perssonal_detail.county && (
                    <tr>
                      <td style={{ minWidth: '15em' }}>County</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.county}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ minWidth: '15em' }}>
                      Do you have a right to work in the UK
                    </td>
                    <td>
                      <span className="title-crop">
                        {props.right_to_work_selected}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Cv Uploaded</td>
                    <td>
                      <span>{props.file_name}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>
                      Profile Picture Uploaded
                    </td>
                    <td>
                      <span>{props.profile_name}</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <section
              className="dashboard-page-title"
              style={{ marginTop: '10px' }}
            >
              <h2>If you would like to sign up to our newsletter click here</h2>
              <br />
              <h2>
                Your personal data is important to us so we strive to keep it
                safe. The details you have provided will be kept on file with
                out organization permanent. If you wish to have the details
                updated or permanently If you wish to have the details updated
                or permanently removed please send us an email at
                GDPR@carerconnet.com
              </h2>
              <br />
              <h2>Thank you for your interest in working with us</h2>
            </section>
          </div>
        </div>
      </div>
    </>
  );
  // }else{
  //             return(
  //                 <Navigate to="/login" />
  //              )
  // }
};

export default CvCompleteView;
